import { dictionaryApi } from 'common/api/entitiesApi'
import { FC } from 'react'

import { DictionarySelector, DictionarySelectorProps } from './DictionarySelector'

export const CountrySelector: FC<DictionarySelectorProps> = ({ multiple = true, mode, ...props }) => (
  <DictionarySelector
    {...props}
    cacheKey="country"
    loader={() => dictionaryApi.countries()}
    errorText="Can't load available countries"
    mode={multiple ? (mode ?? 'multiple') : undefined}
  />
)
